// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__ufN3x","link":"HeaderSimple_link__InSRG"};